import React from 'react';
import { useIntl } from 'react-intl';
import copyToClipboard from 'copy-to-clipboard';
import { func, shape, string } from 'prop-types';
import {
  IconButton,
  Typography,
  withStyles,
} from '@material-ui/core';

import styles from './styles';
import { getI18n } from '../../../../utils/intl';
import {
  DetailsPanelContainer,
} from '../../../../components';
import {
  ALERT_SUCCESS,
} from '../../../../constants';

export const copy = ({ intl, proxyUrl, notifyMessages }) => {
  notifyMessages(ALERT_SUCCESS, intl.getI18nMessage('label.proxy.details.proxy.url.copied'));
  copyToClipboard(proxyUrl);
  setTimeout(() => notifyMessages('', ''), 3000);
};

export const ProxyUrlContent = ({ classes = {}, proxyUrl, notifyMessages }) => {
  const intl = getI18n(useIntl());
  return (
    <IconButton
      className={classes.copyProxyUrl}
      onClick={() => copy({ intl, proxyUrl, notifyMessages })}
    >
      <Typography variant="body1">{intl.getI18nMessage('label.copy.button')}</Typography>
    </IconButton>
  );
};

ProxyUrlContent.propTypes = {
  classes: shape({}),
  notifyMessages: func,
  proxyUrl: string,
};
ProxyUrlContent.displayName = 'ProxyUrlContent';

export const ProxyUrl = ({ classes = {}, proxyUrl, notifyMessages }) => {
  const intl = getI18n(useIntl());
  return (
    <DetailsPanelContainer
      id="overview-proxy-url"
      title={intl.getI18nMessage('label.proxy.details.page.overview.proxy.url')}
      subTitle={proxyUrl}
      smallFont
      content={
        <ProxyUrlContent
          classes={classes}
          proxyUrl={proxyUrl}
          notifyMessages={notifyMessages}
        />
      }
    />
  );
}

export default (
  withStyles(styles)
)(ProxyUrl);

ProxyUrl.propTypes = {
  classes: shape({}),
  proxyUrl: string,
  notifyMessages: func,
};
ProxyUrl.displayName = 'ProxyUrl';



// WEBPACK FOOTER //
// ./src/pages/Proxy/Details/Overview/proxyUrl.js